module.exports = __webpack_public_path__ + "static/media/troll.8e45be35.svg";